import CustomizableGeneric from './CustomizableGeneric';

class Offer extends CustomizableGeneric {
  getTypeName = () => 'Offer';

  getFields = () => ['price', 'priceCurrency', 'availability', 'eligibleRegion', 'availableDeliveryMethod'];
}

export default Offer;
